import {
  ActionButton,
  EventItem,
  LinkButton,
  Utils,
  NoItemFound,
  YearToggleSwitch,
} from "Components";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { FaTimesCircle } from "react-icons/fa";
import styled from "styled-components";
import { theme } from "Theme";
import {
  FilterButton,
  FormGroup,
  Gap,
  ResetButton,
  SectionHeading,
  SectionHeadingButton,
  Title,
} from "Styles";
import voca from "voca";
const ActionSection = styled.div`
  width: 100%;
  display: block;
  position: relative;
  z-index: 2;
  @media (max-width: ${theme.breakpoints.m}) {
  }
  margin: 0 auto;
  padding: 0;
  h2 {
    margin: 0;
  }
`;
const FilterSection = styled.section`
  background: #fff;
  /* border-radius: ${theme.borderRadius.ui}; */
  /* box-shadow: ${theme.shadow.feature.small.default}; */
  /* border: 1px solid #ddd; */
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-radius: 16px;
  box-shadow: 0px 15px 25px rgb(0 0 0 / 20%);
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    /* padding: 1rem 2rem; */
    padding: 2rem 2rem;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  max-width: ${theme.layout.base};
  label {
    font-weight: 500;
  }
`;
const FilterGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    span {
      display: flex;
      justify-content: flex-start;
    }
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }
  grid-gap: 16px;
`;
const Grid = styled.div`
  margin: ${(props) => (props.featured ? "0 auto;" : "1rem auto;")};
  display: ${(props) => (props.featured ? "block;" : "grid;")};
  grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(33%, 1fr));
    margin: ${(props) => (props.featured ? "-5rem auto 0;" : "1rem auto;")};
  }
  @media (min-width: ${theme.breakpoints.l}) {
    grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  }
  grid-gap: 16px;
`;
const HeadingText = styled.div`
  position: relative;
  display: block;
  margin: 0;
  padding-right: 12px;
  .text {
    display: inline;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  align-items: center;
  font-weight: normal;
  font-size: ${theme.fontSize.medium};
  span {
    margin-left: 1rem;
    background: none;
    border-radius: ${theme.borderRadius.elements};
    border: 1px solid ${theme.colors.primary.base};
    color: ${theme.colors.primary.base};
    cursor: pointer;
    font-weight: normal;
    font-size: ${theme.fontSize.small};
    outline: 0;
    padding: 0px 4px;
    white-space: nowrap;
  }
`;
const pageLimit = 12;
export default function EventsGrid(props) {
  const {
    track,
    header,
    title,
    countdown,
    featured,
    big,
    button,
    filter,
    events,
    show,
    coming,
    brands,
    teaser,
    item_action,
  } = props;
  let [limit, setLimit] = useState(pageLimit);
  let [queryObject, setQueryObject] = useState({});
  let [selectedTypes, setSelectedTypes] = useState(null);
  let [selectedRegion, setSelectedRegion] = useState(null);
  let [selectedMonths, setSelectedMonths] = useState(null);
  let [selectedAudience, setSelectedAudience] = useState(null);
  let [passed, setPassed] = useState(false);
  let [eventsCollection, setEventsCollection] = useState([]);
  let [selectedBrandType, setSelectedBrandType] = useState(null);
  useEffect(() => {
    setQueryObject(Utils.getWindowParamsObj);
  }, [events]);
  useEffect(() => {
    async function readQueryObject() {
      await setSelectedTypes(queryObject.type);
      await setSelectedAudience(queryObject.audience);
      await setSelectedRegion(queryObject.region);
      await setSelectedMonths(queryObject.month);
      await setPassed(queryObject?.passed ? true : false);
      await setSelectedBrandType(queryObject.brand);
    }
    readQueryObject();
  }, [queryObject]);
  useEffect(() => {
    // Today or future Events
    let futureEvents = events.filter((event) => {
      return !moment(event.node.date).isBefore(moment(), "day");
    });
    futureEvents.sort((a, b) => (a.node.date > b.node.date ? 1 : -1));
    // passed Events
    let pastEvents = events.filter((event) => {
      return moment(event.node.date).isBefore(moment(), "day");
    });
    pastEvents.sort((a, b) => (a.node.date > b.node.date ? -1 : 1));
    // 2024 Events
    let nextYearEvents = events.filter((event) => {
      return moment(event.node.date).isAfter(moment("01-01-2023"), "day");
    });
    nextYearEvents.sort((a, b) => (a.node.date > b.node.date ? 1 : -1));
    if (coming) {
      setEventsCollection(futureEvents);
      setLimit(pageLimit);
    } else if (passed) {
      setEventsCollection(pastEvents);
      setLimit(pageLimit);
    } else if (teaser) {
      setEventsCollection(nextYearEvents);
      setLimit(pageLimit);
    } else {
      setEventsCollection(futureEvents);
      setLimit(pageLimit);
    }
    Utils.setUrlParam("passed", passed ? true : null);
  }, [events, passed]);
  const onLoadMore = () => {
    setLimit(limit + pageLimit);
  };
  const resetSelection = (setFunction, value) => {
    setFunction(value);
    setLimit(pageLimit);
  };
  const updateURLParams = async (key, value) => {
    await Utils.setUrlParam(key, value);
  };
  const allTypes = ["conferences", "virtual/webinar"];
  const allAudience = [
    "CFO",
    "CIO",
    "CISO",
    "CMO",
    "CHRO",
    "CX",
    "DevOps",
    "DevSecOps",
  ];
  const allRegions = ["APAC", "EMEA", "LATAM", "North America"];
  const allMonths = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  let filteredBrands = eventsCollection.slice(0, show);
  const activeBrands = [];
  filteredBrands.map((data) => {
    if (activeBrands.indexOf(data.node.brand) === -1) {
      activeBrands.push(data.node.brand);
    }
  });
  const activeMonths = [];
  filteredBrands.map((data) => {
    if (activeMonths.indexOf(moment(data.node.date).format("MMM")) === -1) {
      activeMonths.push(moment(data.node.date).format("MMM"));
    }
  });
  // FILTER THE OBJECT
  let EventsObject = eventsCollection;
  // EventsObject = selectedAudience ? EventsObject.filter((obj) => //---console.log("obj: ", obj)) : EventsObject
  EventsObject = selectedAudience
    ? EventsObject.filter(
        (obj) => selectedAudience === obj.node.audience.toLowerCase()
      )
    : EventsObject;
  EventsObject = selectedBrandType
    ? EventsObject.filter(
        (obj) => selectedBrandType === obj.node.brand.toLowerCase()
      )
    : EventsObject;
  EventsObject = !selectedMonths
    ? EventsObject
    : EventsObject.filter((obj) =>
        selectedMonths.includes(
          voca.slugify(moment(obj.node.date).format("MMM"))
        )
      );
  if (selectedRegion) {
    // //---console.log(selectedRegion)
    // //---console.log(EventsObject.length)
    // EventsObject = EventsObject.filter((obj) => selectedRegion.some((val) => obj.node.region.indexOf(val) !== -1))
    // EventsObject = EventsObject.filter((obj) => selectedRegion.some((val) => obj.node.region.toLowerCase() === val))
    EventsObject = EventsObject.filter(
      (obj) => selectedRegion === voca.slugify(obj.node.region)
    );
  }
  EventsObject = !selectedTypes
    ? EventsObject
    : EventsObject.filter((obj) =>
        selectedTypes.includes(voca.slugify(obj.node.eventType))
      );
  let GridTitleDate = voca.capitalize(selectedMonths ? selectedMonths : "");
  let GridTitleAudience = voca.upperCase(selectedAudience);
  let GridTitleRegion = voca.upperCase(selectedRegion ? selectedRegion : "");
  let eventsCount = EventsObject.length;
  return (
    <ActionSection>
      {filter && (
        <>
          <FilterSection>
            <div id="formControlsSelect" className="form">
              {allTypes && (
                <FormGroup className="form-group">
                  <FilterGrid>
                    <label htmlFor="">Type:</label>
                    <span>
                      <FilterButton
                        value={null}
                        onClick={async () => {
                          await resetSelection(setSelectedTypes, null);
                          await updateURLParams("type", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Type: ALL`}
                        className={`${!selectedTypes ? "active" : ""}`}
                      >
                        ALL
                      </FilterButton>
                      <FilterButton
                        value={"conference"}
                        onClick={async () => {
                          await resetSelection(
                            setSelectedTypes,
                            "conference gala"
                          );
                          await updateURLParams("type", "conference");
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Type: ${voca.capitalize(
                          "conferences"
                        )}`}
                        data-name={"conferences"}
                        className={`${
                          selectedTypes === "conference" ||
                          selectedTypes === "conference gala"
                            ? "active"
                            : ""
                        }`}
                      >
                        Conferences
                      </FilterButton>
                      {/* <FilterButton
                        value={"gala"}
                        onClick={async () => {
                          await resetSelection(setSelectedTypes, "gala")
                          await updateURLParams("type", "gala")
                          setLimit(pageLimit)
                        }}
                        data-gtm={`Calendar Button | Type: ${voca.capitalize("gala")}`}
                        data-name={"gala"}
                        className={`${selectedTypes === "gala" ? "active" : ""}`}>
                        Gala
                      </FilterButton> */}
                      <FilterButton
                        value={"webinar"}
                        onClick={async () => {
                          await resetSelection(setSelectedTypes, "webinar");
                          await updateURLParams("type", "webinar");
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Type: ${voca.capitalize(
                          "webinar"
                        )}`}
                        data-name={"webinar"}
                        className={`${
                          selectedTypes === "webinar" ? "active" : ""
                        }`}
                      >
                        Virtual / Webinars
                      </FilterButton>
                      <ResetButton
                        className={`${selectedTypes ? "active" : ""}`}
                        onClick={async () => {
                          await resetSelection(setSelectedTypes, "");
                          await updateURLParams("type", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Reset Type`}
                      >
                        <IconContext.Provider value={{ className: "svg-icon" }}>
                          <FaTimesCircle />
                        </IconContext.Provider>
                      </ResetButton>
                    </span>
                  </FilterGrid>
                </FormGroup>
              )}
              {allAudience && (
                <FormGroup className="form-group">
                  <FilterGrid>
                    <label htmlFor="">Audience:</label>
                    <span>
                      <FilterButton
                        value={null}
                        onClick={async () => {
                          await resetSelection(setSelectedAudience, null);
                          await updateURLParams("audience", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Audience: ALL`}
                        className={`${!selectedAudience ? "active" : ""}`}
                      >
                        ALL
                      </FilterButton>
                      {allAudience.map((audience, i) => {
                        return (
                          <FilterButton
                            key={i}
                            value={audience.toLowerCase()}
                            onClick={async () => {
                              await setSelectedAudience(audience.toLowerCase());
                              await updateURLParams(
                                "audience",
                                audience.toLowerCase()
                              );
                            }}
                            data-gtm={`Calendar Button | Audience: ${audience.toUpperCase()}`}
                            data-name={audience
                              .replace("audience", "")
                              .toLowerCase()}
                            className={`${
                              selectedAudience === audience.toLowerCase()
                                ? "active"
                                : ""
                            }`}
                          >
                            {audience}
                          </FilterButton>
                        );
                      })}
                      <ResetButton
                        className={`${selectedAudience ? "active" : ""}`}
                        onClick={async () => {
                          await resetSelection(setSelectedAudience, null);
                          await updateURLParams("audience", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Reset Audience`}
                      >
                        <IconContext.Provider value={{ className: "svg-icon" }}>
                          <FaTimesCircle />
                        </IconContext.Provider>
                      </ResetButton>
                    </span>
                  </FilterGrid>
                </FormGroup>
              )}
              {allRegions && (
                <FormGroup className="form-group">
                  <FilterGrid>
                    <label htmlFor="">Region:</label>
                    <span>
                      <FilterButton
                        value={null}
                        onClick={async () => {
                          await resetSelection(setSelectedRegion, null);
                          await updateURLParams("region", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Region: ALL`}
                        // className={`${!selectedRegion || !selectedRegion[0] ? "active" : ""}`}>
                        className={`${selectedRegion ? "" : "active"}`}
                      >
                        ALL
                      </FilterButton>
                      {allRegions.map((region, i) => {
                        return (
                          <FilterButton
                            key={i}
                            value={region.toLowerCase()}
                            onClick={async () => {
                              //---console.log(voca.slugify(region))
                              await resetSelection(
                                setSelectedRegion,
                                voca.slugify(region)
                              );
                              await updateURLParams(
                                "region",
                                voca.slugify(region)
                              );
                              setLimit(pageLimit);
                            }}
                            data-gtm={`Calendar Button | Region: ${voca.capitalize(
                              region
                            )}`}
                            data-name={voca.slugify(region)}
                            className={`${
                              selectedRegion &&
                              selectedRegion.includes(voca.slugify(region))
                                ? "active"
                                : ""
                            }`}
                          >
                            {voca.capitalize(region)}
                          </FilterButton>
                        );
                      })}
                      <ResetButton
                        className={`${
                          selectedRegion && selectedRegion[0] ? "active" : ""
                        }`}
                        onClick={async () => {
                          await resetSelection(setSelectedRegion, null);
                          await updateURLParams("region", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Reset Region`}
                      >
                        <IconContext.Provider value={{ className: "svg-icon" }}>
                          <FaTimesCircle />
                        </IconContext.Provider>
                      </ResetButton>
                    </span>
                  </FilterGrid>
                </FormGroup>
              )}
              {allMonths && !teaser && (
                <FormGroup className="form-group">
                  <FilterGrid>
                    <label htmlFor="">Month:</label>
                    <span>
                      <FilterButton
                        value={null}
                        onClick={async () => {
                          await resetSelection(setSelectedMonths, null);
                          await updateURLParams("month", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Month: ALL`}
                        className={`${!selectedMonths ? "active" : ""}`}
                      >
                        ALL
                      </FilterButton>
                      {allMonths.map((month, i) => {
                        return (
                          <FilterButton
                            key={i}
                            value={voca.slugify(month)}
                            onClick={async () => {
                              await resetSelection(
                                setSelectedMonths,
                                voca.slugify(month)
                              );
                              await updateURLParams(
                                "month",
                                voca.slugify(month)
                              );
                              setLimit(pageLimit);
                            }}
                            data-gtm={`Calendar Button | Month: ${voca.capitalize(
                              month
                            )}`}
                            data-name={voca.slugify(month)}
                            className={`${
                              selectedMonths === voca.slugify(month)
                                ? "active"
                                : ""
                            }`}
                          >
                            {voca.capitalize(month)}
                          </FilterButton>
                        );
                      })}
                      <ResetButton
                        className={`${selectedMonths ? "active" : ""}`}
                        onClick={async () => {
                          await resetSelection(setSelectedMonths, null);
                          await updateURLParams("month", null);
                          setLimit(pageLimit);
                        }}
                        data-gtm={`Calendar Button | Reset Month`}
                      >
                        <IconContext.Provider value={{ className: "svg-icon" }}>
                          <FaTimesCircle />
                        </IconContext.Provider>
                      </ResetButton>{" "}
                      <YearToggleSwitch
                        id="year"
                        name="year"
                        optionLabels={["New", "Old"]}
                        checked={!passed}
                        onChange={async () => {
                          await setPassed(!passed);
                        }}
                      />
                    </span>
                  </FilterGrid>
                </FormGroup>
              )}
            </div>
          </FilterSection>
          <br />
          <br />
        </>
      )}
      {header && title && (
        <>
          <SectionHeading>
            <Title>{title}</Title>
            {button && (
              <SectionHeadingButton>
                <LinkButton to={"/events/"}>View all events</LinkButton>
              </SectionHeadingButton>
            )}
          </SectionHeading>
        </>
      )}
      {header && !title && (
        <>
          <SectionHeading>
            <HeadingText>
              <small style={{ color: theme.colors.red.base }} className="text">
                Showing :{" "}
              </small>
              <br />
              {GridTitleDate}{" "}
              <b className="text">
                {GridTitleAudience ? GridTitleAudience : ""}{" "}
              </b>{" "}
              events in{" "}
              <b className="text">
                {!GridTitleRegion ? "All Regions" : GridTitleRegion}
              </b>
              <span>{eventsCount}</span>
            </HeadingText>
            {button && (
              <SectionHeadingButton>
                {/* <ShareCalendar
                  to={`mailto:?subject=CXOsync%20Events%20Calendar&body=${GridTitle}%0A${encodeURIComponent(
                    searchQuery
                  )}%0A`}
                  target="_blank"
                  track={track}
                  title={`Share ${GridTitle}`}>
                  <IconContext.Provider value={{ className: "react-icons" }}>
                    <FaShareSquare />
                  </IconContext.Provider>
                  {searchQuery}
                </ShareCalendar> */}
                <ResetButton
                  className={`${
                    selectedMonths
                      ? "active"
                      : "" || selectedRegion
                      ? "active"
                      : "" || selectedAudience
                      ? "active"
                      : "" || selectedTypes
                      ? "active"
                      : ""
                  }`}
                  onClick={async () => {
                    await updateURLParams("type", null);
                    await resetSelection(setSelectedTypes, null);
                    await updateURLParams("audience", null);
                    await resetSelection(setSelectedAudience, null);
                    await updateURLParams("region", null);
                    await resetSelection(setSelectedRegion, null);
                    await updateURLParams("month", null);
                    await resetSelection(setSelectedMonths, null);
                    await updateURLParams("passed", false);
                    await resetSelection(setPassed, false);
                    setLimit(pageLimit);
                  }}
                  data-gtm={`Calendar Button | Reset Filters`}
                >
                  Reset Filter
                </ResetButton>
              </SectionHeadingButton>
            )}
          </SectionHeading>
        </>
      )}
      <Grid featured={featured}>
        <>
          {EventsObject.slice(0, show ? show : limit).map((data, i) => {
            let event = data.node;
            const eventLink = event.webinarLink || event.eventSite;
            return (
              <EventItem
                key={i}
                banner={event.image != null ? event.image : ""}
                big={big}
                brandName={event.brand}
                countdown={countdown}
                eventDate={event.date}
                eventCity={event.stateCity}
                eventEnd={event.time ? event.time.split(" - ")[1] : ""}
                eventEndDate={event.date}
                eventId={event.id}
                eventName={event.events}
                eventRegion={event.region}
                eventCountryISO={event.countryIso}
                eventSponsors={event ? event.companies : ""}
                eventStart={event.time ? event.time.split(" - ")[0] : ""}
                eventState={event.state}
                eventType={event.eventType}
                eventTime={event.eventTime}
                eventPanel={event.panel}
                featured={featured}
                track={track}
                eventURL={eventLink}
                teaser={teaser}
                item_action={eventLink ? null : (e) => {
                  item_action && item_action(e);
                }}
              />
            );
          })}
        </>
      </Grid>
      {EventsObject.slice(0, show ? show : limit).length <= 0 ? (
        <NoItemFound />
      ) : (
        ""
      )}
      {!show && EventsObject.length > limit ? (
        <>
          <Gap />
          <div style={{ textAlign: "center" }}>
            <ActionButton
              onClick={() => onLoadMore()}
              button={true}
              track={"Load more"}
              title={`Load more`}
            >
              Load More...
            </ActionButton>
          </div>
        </>
      ) : null}
    </ActionSection>
  );
}
